import React from 'react';
import { Autocomplete, Checkbox, FormControlLabel, Paper, Stack, TextField, Typography } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const BulkAssignmentGradeFormDialog = ({ open, onClose, onSubmit, bulkFormData, setBulkFormData, classes, scales, onClassToggle, saving, isMobile = false }) => (
  <FormDialog open={open} onClose={onClose} onSubmit={onSubmit} title="Bulk Assign Grading Scale" saving={saving} disabled={!bulkFormData.class_ids.length} isMobile={isMobile}>
    <Stack spacing={2} sx={{ pt: 1 }}>
      <Autocomplete
        fullWidth
        options={scales}
        value={scales.find((s) => Number(s.id) === Number(bulkFormData.grading_scale_id)) || null}
        onChange={(_, v) => setBulkFormData({ ...bulkFormData, grading_scale_id: v?.id || '' })}
        getOptionLabel={(o) => `${o.scale_name || 'Scale'} (${o.scale_code || '-'})`}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        renderInput={(params) => <TextField {...params} label="Grading Scale" required />}
      />
      <TextField
        fullWidth type="number" label="Academic Year"
        value={bulkFormData.academic_year}
        onChange={(e) => setBulkFormData({ ...bulkFormData, academic_year: parseInt(e.target.value, 10) })}
        inputProps={{ min: 2020, max: new Date().getFullYear() + 1 }}
        required
      />
      <Typography variant="subtitle2">Select Classes ({bulkFormData.class_ids.length} selected)</Typography>
      <Paper sx={{ p: 2, maxHeight: 260, overflow: 'auto' }}>
        {classes.map((cls) => (
          <FormControlLabel
            key={cls.id}
            control={<Checkbox checked={bulkFormData.class_ids.includes(cls.id)} onChange={() => onClassToggle(cls.id)} />}
            label={cls.name}
          />
        ))}
      </Paper>
    </Stack>
  </FormDialog>
);

export default BulkAssignmentGradeFormDialog;
